const noop = () => {
  return;
};

export { noop };
//# sourceMappingURL=noop.js.map
